export const dataset = process.env.NEXT_PUBLIC_SANITY_DATASET || 'production'
export const projectId = process.env.NEXT_PUBLIC_SANITY_PROJECT_ID || 'v528phcz'
export const apiVersion = '2023-07-01'
export const previewSecretId = 'preview.secret'

export const config = {
	useCdn: false,
	perspective: 'published',
	dataset,
	projectId,
	apiVersion,
	token: process.env.SANITY_API_TOKEN,
}

// sanity types to next routes resolution
export const nextRoutes = {
	// constant
	home: '/',
	careerOverview: '/career',
	aboutPage: '/about',
	manifestoPage: '/manifesto',
	community: '/community',
	partnership: '/partnership',

	// content
	page: '/:slug',
	legal: '/legal/:slug',
	article: '/article/:slug',
	leadership: '/leadership/:slug',
	merchItem: '/merch/:slug',
	career: '/career/:slug',
	landing: '/landing/:slug',
	experienceList: '/experiences',
	// ecommerce
	product: '/experience/:slug',
	brochure: '/brochure/:slug',
	stay: '/stay/:slug',
	destination: '/destination/:slug',

	// auth
	// authDispatch: '/auth',
	// activate: '/auth/activate',
	// forgottenPassword: '/auth/password-forgotten',
	// resetPassword: '/auth/reset-password',
	// requestActivation: '/auth/request-activation',
	// signIn: '/auth/sign-in',
	// signUp: '/auth/sign-up',

	// account
	// myAccount: '/account',
	// myOrders: '/account/orders',
	// myAddresses: '/account/addresses',
}
